import { interval, of, EMPTY } from 'rxjs'
import { pluck, mergeMap, map, distinctUntilChanged, takeUntil, filter } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { SET_BOOKING_STATUS, EXTEND_GIG_TERMINATION, EXTEND_GIG_TERMINATION_SUCCESS } from '../../../constants/actionTypes'
import { status as gigStatus } from '@bt-react/constants'
import { DeadMansHandleStatus } from '../../../../lib/getDeadMansHandleStatus/getDeadMansHandleStatus'
import { showDeadMansHandle } from '../../../actions/ui/uiActions'
import { ReduxAction, State } from '../../../reducers/reducerType'
import usernameLib from '../../../../lib/username'
import { roomTypes } from '../../../actions/room/roomTypes'
import { actionTerminateGig, terminateGig } from '../../../actions/gig/gigActions'

const deadMansHandle$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>, { getDeadMansHandleStatus }) => action$.pipe(
  ofType(SET_BOOKING_STATUS, EXTEND_GIG_TERMINATION_SUCCESS),
  pluck('payload'),
  filter(status =>
    !usernameLib.isWatchScreen(state$.value.config.username || '') &&
    (status === gigStatus.OVERRUN || state$.value.ui.status === gigStatus.OVERRUN)
  ),
  mergeMap(() => {

    return interval(1000).pipe(
      takeUntil(
        action$.pipe(
          ofType(terminateGig().type, EXTEND_GIG_TERMINATION, roomTypes.TEAR_DOWN_ROOM_SUCCESS)
        )
      ),
      filter(() => typeof state$.value.room.gigTerminationTime !== 'undefined'),
      map(() => getDeadMansHandleStatus(state$.value.room.gigTerminationTime)),
      filter((gigStatus: DeadMansHandleStatus) =>
        gigStatus === DeadMansHandleStatus.KILL ||
        (gigStatus === DeadMansHandleStatus.WARN && !state$.value.ui.isDeadMansHandleOpen)
      ),
      distinctUntilChanged((previous, current) => previous === current),
      mergeMap(gigStatus => {

        switch (gigStatus) {

          case DeadMansHandleStatus.KILL:
            return of(actionTerminateGig())
          case DeadMansHandleStatus.WARN:
            return of(showDeadMansHandle())
          default:
            return EMPTY

        }

      })
    )

  }

  )
)

export default deadMansHandle$
